export default "__VITE_ASSET__DIvuba86__"